import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  job: [],
  loading: false,
  error: null,
  totalPages: 0,
  page: 1,
  detail: null,
  active: [],
};

const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    fetchJobRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchJobSuccess: (state, action) => {
      state.job = action.payload.job;
      state.totalPages = action.payload.totalPages;
      state.page = action.payload.currentPage;
      state.loading = false;
    },
    fetchJobFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    detailJobRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    detailJobSuccess: (state, action) => {
      state.detail = action.payload;
      state.loading = false;
    },
    detailJobFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addJobRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    addJobSuccess: (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.job.push(action.payload);
      }
    },
    addJobFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateJobRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateJobSuccess: (state, action) => {
      state.loading = false;
      const updatedJob = action.payload;
      if (updatedJob?.id) {
        const index = state.job.findIndex((item) => item.id === updatedJob.id);
        if (index >= 0) {
          state.job[index] = updatedJob;
        }
      }
    },
    updateJobFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteJobRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteJobSuccess: (state, action) => {
      state.loading = false;
      state.job = state.job.filter((item) => item.id !== action.payload);
    },
    deleteJobFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchJobRequest,
  fetchJobSuccess,
  fetchJobFailure,
  detailJobRequest,
  detailJobSuccess,
  detailJobFailure,
  addJobRequest,
  addJobSuccess,
  addJobFailure,
  updateJobRequest,
  updateJobSuccess,
  updateJobFailure,
  deleteJobRequest,
  deleteJobSuccess,
  deleteJobFailure,
} = jobSlice.actions;

export default jobSlice.reducer;
